import { render, staticRenderFns } from "./CommonLabel.vue?vue&type=template&id=ef265810&scoped=true&"
import script from "./CommonLabel.vue?vue&type=script&lang=ts&"
export * from "./CommonLabel.vue?vue&type=script&lang=ts&"
import style0 from "./CommonLabel.vue?vue&type=style&index=0&id=ef265810&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef265810",
  null
  
)

export default component.exports